<template>
  <div class="nodata-container">
    <div class="text-center">
      <div class="mb-3">
        <icon name="regular/times-circle" scale="3.5" class="text-danger" />
      </div>
      <h3 class="mb-3 font-weight-normal">Požadovaná stránka nebola nájdená</h3>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {}
  },
  created: function () {},
  beforeDestroy: function () {},
  methods: {},
}
</script>
